import React from 'react';
import get from 'lodash/get';
import { Label } from '@grubhubprod/gh-cookbook-react';
import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';
import { getDateFormatFromUTC } from 'src/utilities/formatDate';

export interface FirstOrderDateProps {
  name: string;
}

export function FirstOrderDate({ name }: FirstOrderDateProps): JSX.Element {
  const { corpData } = useCorporateFormContext();

  return (
    <>
      <Label inputSize="medium">JAVA First Order Date</Label>
      {getDateFormatFromUTC(get(corpData, name))}
    </>
  );
}
